import { render, staticRenderFns } from "./banweix.vue?vue&type=template&id=367695bc&scoped=true"
import script from "./banweix.vue?vue&type=script&lang=js"
export * from "./banweix.vue?vue&type=script&lang=js"
import style0 from "./banweix.vue?vue&type=style&index=0&id=367695bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367695bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('367695bc')) {
      api.createRecord('367695bc', component.options)
    } else {
      api.reload('367695bc', component.options)
    }
    module.hot.accept("./banweix.vue?vue&type=template&id=367695bc&scoped=true", function () {
      api.rerender('367695bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/banweix.vue"
export default component.exports